var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable prefer-destructuring */
import React from 'react';
import { matchRoutes } from 'react-router-config';
import cloneDeep from 'lodash.clonedeep';
import { AceRouter, transformRoutes } from '@ies/ace-router';
import composeRuntimePlugins from './common/composeRuntimePlugins';
import { renderer } from './common/renderer';
import matchedPath from './common/matchedPath';
var removeBasePath = function (path, base) {
    if (base === '/' || !base) {
        return path;
    }
    return path.replace(/^\//.test(base) ? base : "/" + base, '') || '';
};
function getPageInitialProps(_a, isMPA) {
    var _b;
    var Page = _a.Page, routes = _a.routes, context = _a.context, routePath = _a.routePath;
    return __awaiter(this, void 0, void 0, function () {
        var cloneRoutes, matchedRoutes, promise, _loop_1, matchedRoutes_1, matchedRoutes_1_1, route, e_1_1;
        var e_1, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!isMPA) return [3 /*break*/, 1];
                    if (Page === null || Page === void 0 ? void 0 : Page.getInitialProps) {
                        return [2 /*return*/, [
                                Promise.resolve(Page.getInitialProps(context)).then(function (data) { return ({
                                    pageProps: data,
                                }); }),
                            ]];
                    }
                    return [2 /*return*/, []];
                case 1:
                    cloneRoutes = cloneDeep(routes);
                    transformRoutes(cloneRoutes);
                    matchedRoutes = (matchRoutes(cloneRoutes, routePath) || []).filter(function (route) { return route.route.component; }) || [];
                    promise = [];
                    _loop_1 = function (route) {
                        var _e, id, component, getInitialProps;
                        return __generator(this, function (_f) {
                            switch (_f.label) {
                                case 0:
                                    _e = route === null || route === void 0 ? void 0 : route.route, id = _e.id, component = _e.component;
                                    getInitialProps = void 0;
                                    if (!(typeof (component === null || component === void 0 ? void 0 : component.load) === 'function')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, component.load()];
                                case 1:
                                    // @ts-ignore not necessary getInitialProps type
                                    getInitialProps = (_b = (_f.sent()).default) === null || _b === void 0 ? void 0 : _b.getInitialProps;
                                    return [3 /*break*/, 3];
                                case 2:
                                    getInitialProps = component.getInitialProps;
                                    _f.label = 3;
                                case 3:
                                    if (getInitialProps) {
                                        /* eslint max-depth: 0 */
                                        if (typeof getInitialProps !== 'function') {
                                            throw new Error('getInitialProps needs to be a function！');
                                        }
                                        promise = __spreadArray(__spreadArray([], __read(promise)), [
                                            Promise.resolve(getInitialProps(context)).then(function (data) {
                                                var _a;
                                                return (_a = {},
                                                    _a[id] = data,
                                                    _a);
                                            }),
                                        ]);
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    };
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 7, 8, 9]);
                    matchedRoutes_1 = __values(matchedRoutes), matchedRoutes_1_1 = matchedRoutes_1.next();
                    _d.label = 3;
                case 3:
                    if (!!matchedRoutes_1_1.done) return [3 /*break*/, 6];
                    route = matchedRoutes_1_1.value;
                    return [5 /*yield**/, _loop_1(route)];
                case 4:
                    _d.sent();
                    _d.label = 5;
                case 5:
                    matchedRoutes_1_1 = matchedRoutes_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_1_1 = _d.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (matchedRoutes_1_1 && !matchedRoutes_1_1.done && (_c = matchedRoutes_1.return)) _c.call(matchedRoutes_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/, promise];
            }
        });
    });
}
function appendGetInitialStateToContainer(Container, options) {
    var _this = this;
    var isMPA = options.isMPA, isSSR = options.isSSR, Page = options.Page, routes = options.routes, basename = options.basename;
    var appGetInitialProps = Container.getInitialProps;
    if (!isSSR) {
        return;
    }
    var matched = {};
    Container.getInitialProps = function (context) { return __awaiter(_this, void 0, void 0, function () {
        var routePath, _a, appProps, pageProps, _b, _c, _d, props;
        var _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    routePath = removeBasePath(context.pathname, basename);
                    if (isMPA) {
                        matchedPath(routePath, matched);
                    }
                    _c = (_b = Promise).all;
                    _d = [[
                            appGetInitialProps ? Promise.resolve(appGetInitialProps(context)) : []
                        ]];
                    return [4 /*yield*/, getPageInitialProps({ Page: Page, routes: routes, context: context, routePath: routePath }, isMPA)];
                case 1: return [4 /*yield*/, _c.apply(_b, [__spreadArray.apply(void 0, _d.concat([__read.apply(void 0, [(_f.sent())])]))])];
                case 2:
                    _a = __read.apply(void 0, [_f.sent()]), appProps = _a[0], pageProps = _a.slice(1);
                    props = pageProps.reduce(function (acc, cur) { return (__assign(__assign({}, acc), cur)); }, {});
                    return [2 /*return*/, __assign(__assign(__assign({ _location: (_e = context === null || context === void 0 ? void 0 : context.ctx) === null || _e === void 0 ? void 0 : _e.url }, { app: appProps }), props), matched === null || matched === void 0 ? void 0 : matched.params)];
            }
        });
    }); };
}
export default function renderWithRouter(AppComponent, PageComponent, opts) {
    var _this = this;
    var _a;
    var isSSR = opts.isSSR, isMPA = opts.isMPA, isBrowser = opts.isBrowser, rootElement = opts.rootElement, ssrRenderer = opts.ssrRenderer, shouldReturnAppComponent = opts.shouldReturnAppComponent, router = opts.router, hasServerCompiler = opts.hasServerCompiler, isSSG = opts.isSSG, loadableReady = opts.loadableReady, additionalProps = opts.additionalProps;
    var basename = router.basename;
    var routes = (router === null || router === void 0 ? void 0 : router.routes) || [];
    var lazy = (_a = router === null || router === void 0 ? void 0 : router.lazy) !== null && _a !== void 0 ? _a : false;
    var WrappedApp = null;
    var appConfig = {};
    // 兼容 0.5.x 版本入口默认导出的 appConfig
    // @ts-ignore different type for mobx
    var isAbandoned = typeof AppComponent === 'object' && !AppComponent.$$typeof;
    if (isAbandoned) {
        appConfig = cloneDeep(AppComponent);
        // eslint-disable-next-line
        AppComponent = function (props) {
            var children = props.children;
            var rootContainer = appConfig.rootContainer;
            if (rootContainer) {
                return rootContainer(children);
            }
            return React.createElement(React.Fragment, null, children);
        };
    }
    else {
        appConfig = AppComponent.config || {};
    }
    // ReactDom.render 之后执行，例如微前端主应用挂载子应用就在这个时机
    if (!appConfig.afterRender) {
        appConfig.afterRender = function () { return null; };
    }
    WrappedApp = function (props) { return (React.createElement(AceRouter, __assign({ App: AppComponent, Page: PageComponent, basename: basename, isBrowser: opts.isBrowser, disableRouterGetInitialProps: opts.disableRouterGetInitialProps, initialProps: props, additionalProps: additionalProps, isSSG: isSSG, isSSR: isSSR }, opts.router))); };
    // 用于插件内部修改运行时配置
    WrappedApp.config = appConfig;
    if (isSSG) {
        WrappedApp.getInitialProps =
            AppComponent.getStaticProps &&
                (function (context) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/, AppComponent.getStaticProps({ pathname: context.pathname })];
                }); }); });
    }
    else {
        WrappedApp.getInitialProps = AppComponent.getInitialProps;
    }
    WrappedApp = composeRuntimePlugins((opts === null || opts === void 0 ? void 0 : opts.plugins) || [], WrappedApp, appConfig, opts);
    // 该方法只有 SSR 场景下会执行
    if (!isSSG) {
        appendGetInitialStateToContainer(WrappedApp, { isMPA: isMPA, isSSR: isSSR, Page: PageComponent, routes: routes, basename: basename });
    }
    if (shouldReturnAppComponent) {
        // 只需要拿到组件，不渲染，例如 SSR 和 微前端场景
        return WrappedApp;
    }
    if (isBrowser) {
        if (lazy && hasServerCompiler) {
            loadableReady(function () {
                renderer({ App: WrappedApp, appConfig: appConfig, ssrRenderer: ssrRenderer, hasServerCompiler: hasServerCompiler, rootElement: rootElement });
            });
        }
        else {
            renderer({ App: WrappedApp, appConfig: appConfig, ssrRenderer: ssrRenderer, hasServerCompiler: hasServerCompiler, rootElement: rootElement });
        }
    }
}
//# sourceMappingURL=renderAppWithRouter.js.map